import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserQuotaUsageLogList } from '../../api/userQuotaUsageLog';
import { message } from 'antd';

// 获取用户额度使用记录列表
export const fetchUserQuotaUsageLogs = createAsyncThunk(
  'userQuotaUsageLog/fetchUserQuotaUsageLogs',
  async (params, { rejectWithValue }) => {
    try {
      const response = await getUserQuotaUsageLogList(params);
      return response.data;
    } catch (error) {
      message.error('获取用户额度使用记录列表失败');
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  userQuotaUsageLogList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    searchParams: {
      userId: undefined,
      username: undefined,
      nickname: undefined,
      quotaAccountId: undefined,
      usageType: undefined,
      businessType: undefined,
      businessId: undefined,
      startTime: undefined,
      endTime: undefined
    }
  }
};

const userQuotaUsageLogSlice = createSlice({
  name: 'userQuotaUsageLog',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.userQuotaUsageLogList.searchParams = {
        ...state.userQuotaUsageLogList.searchParams,
        ...action.payload
      };
      
      // 如果传入了页码或每页条数，更新对应的值
      if (action.payload.page) {
        state.userQuotaUsageLogList.current = action.payload.page;
      }
      
      if (action.payload.size) {
        state.userQuotaUsageLogList.size = action.payload.size;
      }
    },
    resetSearchParams: (state) => {
      state.userQuotaUsageLogList.searchParams = {
        userId: undefined,
        username: undefined,
        nickname: undefined,
        quotaAccountId: undefined,
        usageType: undefined,
        businessType: undefined,
        businessId: undefined,
        startTime: undefined,
        endTime: undefined
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserQuotaUsageLogs.pending, (state) => {
        state.userQuotaUsageLogList.loading = true;
      })
      .addCase(fetchUserQuotaUsageLogs.fulfilled, (state, action) => {
        state.userQuotaUsageLogList.loading = false;
        state.userQuotaUsageLogList.data = action.payload.records;
        state.userQuotaUsageLogList.total = action.payload.total;
        state.userQuotaUsageLogList.current = action.payload.current;
        state.userQuotaUsageLogList.size = action.payload.size;
      })
      .addCase(fetchUserQuotaUsageLogs.rejected, (state) => {
        state.userQuotaUsageLogList.loading = false;
      });
  }
});

export const { setSearchParams, resetSearchParams } = userQuotaUsageLogSlice.actions;
export default userQuotaUsageLogSlice.reducer; 